// Main imports
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en-GB',
  messages: {
    'es-MX': {
      session: {
        expired: 'Su sesión ha expirado',
        login: {
          badRequest: 'Datos de inicio de sesión inválidos',
          invalidCredentials: 'Usuario o contraseña incorrectos'
        }
      },
      helpers: {
        errors: {
          disaster: 'Lo sentimos, pero algo salió mal'
        }
      }
    },
    'en-GB': {
      session: {
        expired: 'Your session was expired',
        login: {
          badRequest: 'Invalid login data',
          invalidCredentials: 'Invalid username or password'
        }
      },
      helpers: {
        errors: {
          disaster: 'We are sorry, but something went wrong'
        }
      }
    }
  },
  silentTranslationWarn: true
})
